export default __webpack_public_path__ + "static/general-header-image-8bbd0da3cb38a2c9cd69400c1dfef5e2.jpg";